// extracted by mini-css-extract-plugin
module.exports = {"fragments":"segments-icons_fragments__NIWKT","fragmentsLetter":"segments-icons_fragmentsLetter__LayVo"};